import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullPageLoaderComponent } from './full-page-loader.component';
import { SvgIconModule } from 'app/shared/svg-icon/svg-icon.module';
import { ProgressBarModule } from 'app/shared/progress-bar/progress-bar.module';

@NgModule({
  declarations: [FullPageLoaderComponent],
  imports: [CommonModule, SvgIconModule, ProgressBarModule],
  exports: [FullPageLoaderComponent],
})
export class FullPageLoaderModule {}
